export const OVERVIEW_INSURANCE_HOME = 'home'; // Can't change this to "insurance-home" since it will affect our tracking of the route
export const OVERVIEW_INSURANCE_DETAILS = 'insurance-details';
export const OVERVIEW_WEALTH_HOME = 'wealth-home';
export const OVERVIEW_WEALTH_ACCOUNT = 'wealth-account';
